import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.jsx";
import { FormProvider } from "./context/FormContext.jsx";

createRoot(document.getElementById("root")).render(
  <AuthProvider>
    <FormProvider>
      <Router>
        <App />
      </Router>
    </FormProvider>
  </AuthProvider>,
);
